// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/common.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import http from './config/http'
import Url from './config/url'
import './config/element-ui'
import './config/mint-ui'
import '../theme/index.css'
import cookie from './config/cookie'
import JsonExcel from 'vue-json-excel'
import 'babel-polyfill'
import promise from 'es6-promise'
import echarts from 'echarts'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(router)
Vue.use(vueSwiper)
Vue.prototype.http = http
Vue.prototype.Url = Url
Vue.prototype.$cookie = cookie
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.component('downloadExcel', JsonExcel)
window.vm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
promise.polyfill()
// 路由守卫
router.beforeEach((to, form, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let ssotoken = cookie.get('ssotoken')
    if (!ssotoken) {
      window.vm.$msg('您还未登录,请登录', 'warning')
      // next({
      //   path: '/login',
      //   query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转该路由
      // })
      store.commit('LOSELOGIN', { returnUrl: to.fullPath })
    } else {
      next()
    }
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/main.js